<vitamui-common-table-filter [(filter)]="filter" [showSearchBar]="true" (search)="searchOptions($event)" (filterClose)="filterClose.emit()">
  @if (emptyValueOption()) {
    <vitamui-common-table-filter-option [value]="null" [class.hidden]="hideEmptyValueOption">{{
      emptyValueOption()
    }}</vitamui-common-table-filter-option>
  }
  @for (option of options(); track option; let index = $index) {
    <vitamui-common-table-filter-option [value]="option.value" [class.hidden]="!optionDisplayMap()[index]">{{
      option.label
    }}</vitamui-common-table-filter-option>
  }
</vitamui-common-table-filter>
